import { convertToExportedView } from '@estee/elc-service';
import { ICancellationConfirmation } from './CancellationConfirmation';
import serviceNames from '../../service-setup/ApptBookingService';

/*eslint no-restricted-syntax: ["off"]*/
export default convertToExportedView<ICancellationConfirmation>(
    () => import('./CancellationConfirmation'),
    'elc-appt-booking-cancellation-confirmation',
    serviceNames.cancellationConfirmationViewController
);
